const cartExtraOptions = {
  init() {
    const extraOptionContainers = document.querySelectorAll<HTMLElement>(
      '.jsCartExtraOptions',
    );

    extraOptionContainers.forEach((container) => {
      const rawOptions = container
        .querySelector<HTMLElement>('.jsCartExtraOptionsRaw')
        ?.textContent?.trim();

      if (!rawOptions) {
        container.classList.add('d-none');
        return;
      }

      const options = rawOptions
        .split(';')
        .map((option) => option.trim())
        .filter(Boolean);

      const fragment = document.createDocumentFragment();

      options.forEach((option) => {
        const separatorIndex = option.indexOf(':');

        const name =
          separatorIndex >= 0 ? option.slice(0, separatorIndex).trim() : '';

        const rawValue =
          separatorIndex >= 0
            ? option.slice(separatorIndex + 1).trim()
            : option;

        const value = rawValue
          .replace(/\(\s*\+\s*\$?[\d,.]+\s*\)/gi, '')
          .trim();

        const normalizedName = name.toLowerCase();

        const normalizedValue = value
          .toLowerCase()
          .replace(/[,.!?]/g, '')
          .replace(/\s+/g, ' ')
          .trim();

        const isOptionalToggle =
          normalizedName.includes('auto delivery') ||
          normalizedName.includes('discreet packaging');

        const isOptOutValue =
          normalizedValue === '' ||
          normalizedValue.startsWith('no') ||
          normalizedValue === 'none' ||
          normalizedValue === 'nothing' ||
          normalizedValue === 'not selected' ||
          normalizedValue === 'n/a' ||
          normalizedValue === '-';

        if (isOptionalToggle && isOptOutValue) {
          return;
        }

        if (!value) {
          return;
        }

        const row = document.createElement('div');
        row.className = 'cart-item__extra-option';

        if (name) {
          const nameElement = document.createElement('span');
          nameElement.className = 'cart-item__extra-option-name';
          nameElement.textContent = `${name}: `;

          row.append(nameElement);
        }

        const valueElement = document.createElement('span');
        valueElement.className = 'cart-item__extra-option-value';
        valueElement.textContent = value;

        row.append(valueElement);
        fragment.append(row);
      });

      container.replaceChildren(fragment);

      if (!container.children.length) {
        container.classList.add('d-none');
      }
    });
  },
};

export default cartExtraOptions;
